import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { BtnModakComponent } from '../dumb/button/button.component';
import { StaticServeModule } from '@core/static-serve/static-serve.module';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureIntroductionsItemComponent } from '../dumb/feature-introductions-item/feature-introductions-item.component';
import { CTypesButtonOption } from '../dumb/button/constants/btn-modak.constants';

@Component({
  selector: 'mdk-feature-introductions',
  standalone: true,
  imports: 
  [
    CommonModule,BtnModakComponent,FeatureIntroductionsItemComponent,
    NgOptimizedImage, StaticServeModule,TranslateModule
  ],
  templateUrl: './feature-introductions.component.html',
  styleUrls: ['./styles/feature-introductions.component.mobile.scss']
})
export class FeatureIntroductionsComponent {
  //#region [---- INPUTS & OUTPUTS ----]
  @Input() title!:string
  @Output() buttonClicked : EventEmitter<void> =  new EventEmitter<void>()
  @Output() closeButtonClicked : EventEmitter<void> =  new EventEmitter<void>()
  //#endregion

  //#region [---- PROPERTIES ----]
  public quaternaryButton: string = CTypesButtonOption.QUATERNARY
  //#endregion


  //#region [---- LOGIC ----]
  public buttonClick(): void{
    this.buttonClicked.emit()
  }
  
  public closeButtonClick(): void{
    this.closeButtonClicked.emit()
  }
  
  //#endregion
}
